<template>
  <v-card class="px-5 py-5">
    <v-form ref="form" lazy-validation>
      <v-row>
        <v-col cols="4">
          <v-select-search
            outlined
            hide-details
            label="成立年份"
            :data='createYearItems'
            item-text="label"
            item-value="value"
            :rules="required"
            v-model='form.createYear'>
          </v-select-search>
        </v-col>
        <v-col cols="4">
          <v-text-field :rules="number" hide-details="auto" label="员工数量" v-model="form.workers" outlined  ></v-text-field>
        </v-col>
        <v-col cols="4">
          <v-text-field :rules="number" hide-details="auto" label="知识产权数量" v-model="form.patentNumber" outlined  ></v-text-field>
        </v-col>
      </v-row>

      <v-card class="my-5" outlined>
        <v-card-title class="size-17">
          添加资质 (无期限输入: 0)
          <v-spacer></v-spacer>
          <v-btn text dark small color="primary" @click="addSeniority()">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text v-if="form.seniorityList.length > 0">
          <v-row v-for="(item, idx) in form.seniorityList" :key="idx">
            <v-col cols="12" md="3">
              <v-select-search
                outlined
                hide-details
                label="起始年份"
                :data='startEndYearItems'
                item-text="label"
                item-value="value"
                :rules="required"
                @on-change="selectStartYear($event, idx)"
                v-model='form.seniorityList[idx].startYear'>
              </v-select-search>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field :rules="number" hide-details="auto" @input="inputTimeLimit($event, idx)" label="有效年限" v-model="form.seniorityList[idx].timeLimit" outlined  ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete
                :items="seniorityItems"
                label="企业资质"
                v-model="form.seniorityList[idx].seniorityId"
                hide-details='auto'
                outlined
                item-text='title'
                item-value="id"
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn class="ml-c-30 mt-2" depressed fab small color="primary" @click="form.seniorityList.splice(idx, 1)">
                <v-icon dark>mdi-minus</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text class="text--disabled" @click='item.show = false'>
        关闭
      </v-btn>
      <v-btn color="primary" :loading="loading" @click='save'>
        保存
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { getByPids } from '@/api/system/dictionary.js'
  import { save } from '@/api/customer/detail.js'
  import { policys } from '@/api/policy/index.js'
  import { selectData } from '@/utils/tool.js'
  import VSelectSearch from '@/components/select/v-select-search.vue'

  export default {
    name: 'CustomerDetailAdd',
    components: {
      VSelectSearch
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          data: null
        })
      },
      show: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        number: [
          value => /^[0-99]+.?[0-99]*$/.test(value) || '必须输入数字',
        ],
        seniorityItems: [],
        sourceSeniorityItems: [],
        createYearItems: selectData(20),
        startEndYearItems: selectData(5),
        form: {
          id: '',
          workers: '',
          createYear: '',
          customerId: '',
          patentNumber: '',
          seniorityList: [
            {
              startYear: '',
              timeLimit: '',
              endYear: '',
              seniorityId: '',
            }
          ]
        },
        defForm: {
          id: '',
          workers: 0,
          createYear: '',
          customerId: '',
          patentNumber: 0,
          seniorityList: [
            {
              startYear: '',
              timeLimit: '',
              endYear: '',
              seniorityId: '',
            }
          ]
        }
      }
    },
    methods: {
      setData (boo) {
        if (boo) {
          if (this.item.data.detail) {
            this.form = JSON.parse(JSON.stringify(this.item.data.detail))
          }
        } else {
          this.form = JSON.parse(JSON.stringify(this.defForm))
        }
      },
      inputTimeLimit (ev, idx) {
        if (ev) {
          this.form.seniorityList[idx].endYear = Number(ev) === 0 ? 0 : Number(this.form.seniorityList[idx].startYear) + Number(ev)
        }
      },
      selectStartYear (ev, idx) {
        console.log(this.form.seniorityList[idx])
        if (this.form.seniorityList[idx].timeLimit) {
          this.form.seniorityList[idx].endYear = Number(ev) + Number(this.form.seniorityList[idx].timeLimit)
        }
      },
      addSeniority () {
        this.form.seniorityList.push(
          {
            id: '', startYear: '', timeLimit: '', endYear: '', seniorityId: '',
          }
        )
      },
      save () {
        this.buildFrom()
        if (this.validateForm() && this.$refs.form.validate()) {
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      validateForm () {
        const seniorityIds = []
        this.form.seniorityList.forEach((i) => {
          seniorityIds.push(i.seniorityId)
        })
        if (new Set(seniorityIds).size !== seniorityIds.length) {
          this.$dialog.notify.warning('每个资质只能添加一次', { position: 'top-right', timeout: 4000 })
          return false
        }
        return true
      },
      buildFrom () {
        this.form.customerId = this.item.data.id
      },
      policys () {
        this.loading = true
        policys({}).then(res => {
          if (res.status === 200) {
            this.seniorityItems = res.data
            this.sourceSeniorityItems = res.data
          }
          this.loading = false
        })
      }
    },
    created() {
      this.policys()
    }
  }
</script>

<style lang="sass" scoped>
</style>
